"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SurveyTakerScreen_1 = require("./SurveyTakerScreen");

exports.SurveyTakerScreen = SurveyTakerScreen_1.default;